import React, { createContext, useContext } from 'react';
import store from './Store';

const StoreContext = createContext(store);
interface props{
    children?:any
}
export const StoreProvider: React.FC<props> = ({ children }) => {
  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
};

export const useStore = () => useContext(StoreContext);
